export default function About() {
  return (
    <section id="sobre-mi" className="py-24 bg-white relative overflow-hidden">
      {/* Textura de fondo */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle, #FF6B9D 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>
      </div>

      {/* Estrellas decorativas */}
      <div className="absolute top-20 right-20 text-pink-300 text-2xl">✦</div>
      <div className="absolute top-40 left-32 text-pink-200 text-xl">✦</div>
      <div className="absolute bottom-32 right-40 text-purple-300 text-3xl">✦</div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          {/* Columna izquierda - Foto */}
          <div className="md:col-span-2 flex flex-col items-center space-y-6">
            <div className="relative">
              <div className="w-72 h-72 rounded-full bg-gradient-to-br from-pink-400 to-purple-600 p-1">
                <div className="w-full h-full rounded-full overflow-hidden bg-white">
                  <img
                    src="https://static.readdy.ai/image/89057b92bf34c08c001dd5517bca6a4e/3ae942c9dd537a988b24bd9f09629225.jpeg"
                    alt="Paty - Community Manager"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
            <div className="px-6 py-3 bg-gradient-to-r from-pink-500 to-purple-600 text-white font-semibold rounded-full shadow-lg">
              Community Manager
            </div>
          </div>

          {/* Columna derecha - Contenido */}
          <div className="md:col-span-3 space-y-6">
            <div className="inline-block px-4 py-2 bg-purple-100 text-purple-600 text-sm font-medium rounded-full">
              Sobre mí
            </div>

            <div className="space-y-3">
              <h2 className="text-5xl font-bold text-purple-900">
                Soy Paty
              </h2>
              <p className="text-4xl font-script text-pink-500 italic">
                y transformo marcas en comunidades
              </p>
            </div>

            <div className="space-y-4 text-gray-700 text-lg leading-relaxed">
              <p>
                Mi pasión es ayudar a marcas y emprendedoras a brillar en redes sociales. Con años de experiencia en marketing digital, he aprendido que detrás de cada marca exitosa hay una estrategia sólida, contenido creativo y una conexión genuina con la audiencia.
              </p>
              <p>
                No se trata solo de publicar contenido, se trata de contar historias que conecten, de crear comunidades leales y de generar resultados reales que impulsen tu negocio. Mi enfoque combina creatividad, análisis y estrategia para que tu marca destaque en el mundo digital.
              </p>
              <p>
                Trabajo con marcas que quieren crecer, conectar y vender más a través de redes sociales. Si estás lista para llevar tu presencia digital al siguiente nivel, estoy aquí para ayudarte.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4 pt-6">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-heart-fill text-2xl text-pink-500"></i>
                </div>
                <span className="text-gray-800 font-medium">Pasión</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-heart-fill text-2xl text-pink-500"></i>
                </div>
                <span className="text-gray-800 font-medium">Creatividad</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-heart-fill text-2xl text-pink-500"></i>
                </div>
                <span className="text-gray-800 font-medium">Estrategia</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-heart-fill text-2xl text-pink-500"></i>
                </div>
                <span className="text-gray-800 font-medium">Resultados</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
